import React from "react";

class Index extends React.Component {
  render() {
    return (
      <div>
        <div className="ui center aligned segment">
          <br />
          <h2>
            <strong>Disponible en </strong>
          </h2>
          <br />
          <img
            className="alignnone wp-image-1289 aligncenter"
            src="https://noticias.fpfch.gob.mx/wp-content/uploads/2022/07/googleplay.png"
            alt=""
            width="159"
            height="47"
          />
          <img
            className="alignnone size-full wp-image-1288 aligncenter"
            src="https://noticias.fpfch.gob.mx/wp-content/uploads/2022/07/Appstore.png"
            alt=""
            width="160"
            height="53"
          />
          <p style={{ textAlign: "right" }}>
            <a href="https://observa.gob.mx/">
              <img
                className="alignnone size-full wp-image-1293"
                src="https://noticias.fpfch.gob.mx/wp-content/uploads/2022/07/ICONO-Observa2.png"
                alt=""
                width="250"
                height="66"
              />
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default Index;
